package com.eladfinish.bible.contest.features.verseWidget

import com.eladfinish.bible.contest.analytics.AnalyticsConstants
import kotlinx.serialization.Serializable

/** What opened the widget's settings screen, to tell which way of finding the feature works. */
@Serializable
enum class VerseWidgetEntryPoint(val analyticsValue: String) {
    HOME_TILE(AnalyticsConstants.VerseWidget.ENTRY_HOME_TILE),
    WHATS_NEW_SHEET(AnalyticsConstants.VerseWidget.ENTRY_WHATS_NEW_SHEET),
    WIDGET_GEAR(AnalyticsConstants.VerseWidget.ENTRY_WIDGET_GEAR),
    RANDOM_VERSE_PROMPT(AnalyticsConstants.VerseWidget.ENTRY_RANDOM_VERSE_PROMPT),
    SETTINGS(AnalyticsConstants.VerseWidget.ENTRY_SETTINGS),
}
